import type { Partner } from '@/openapi/v1/msa-customer-partner-manager/partner'

export const DEFAULT_PARTNER: Partner = {
  name: 'Sympower',
  partnerCode: 'SYMPOWER',
}
